import axios from "axios"
import { upperCase } from "lodash"
import { clearAllStorage } from 'actions/user'
import { authToken } from '../v2_actions/auth'

export const makeHeader = () => {
    let token = authToken()
    let config = {
        headers: {
            Authorization: "Token " + token,
            'X-BOSSFOTOS-AUTHENTICATION-TOKEN': 'Token ' + token,
        },
    }
    return config
}

export const signUp = async (data) => {
    removeLocalStorage()
    const json = await axios.post(
        window.LOCAL_SETTINGS.API_BASE + "/api/signup/signup/",
        data
    )
    const token = json.data.token
    if (token) {
        const userInfoData = json.data.user
        if (userInfoData.is_staff) {
           return {token, user:json.data.user} 
        }
    }
    return null
}

export const setInitialPrice = async (country_code, email) => {
    const send_data = { user_email: email, country_code: country_code }
    return await axios.post(
        window.LOCAL_SETTINGS.API_BASE + "/api/v2/photographer/photographer_price/create_initial_price/",
        send_data,
        makeHeader()
    )
}

export const logIn = async (data) => {
    return await axios.post(
        window.LOCAL_SETTINGS.API_BASE + "/api/login/login/",
        data
    )
}

export const logOut = async () => {
    removeLocalStorage()
}

export const forgotPasswordApi = async (data) => {
    return await axios.post(
        window.LOCAL_SETTINGS.API_BASE + "/api/login/send_otp_email/",
        data
    )
}

export const getUserInfo = async () => {
    return await axios.get(
        window.LOCAL_SETTINGS.API_BASE + "/api/user/photographer_user_info/",
        makeHeader()
    )
}

export const sendEmail = async (data) => {
    return await axios.post(
        window.LOCAL_SETTINGS.API_BASE +
            "/api/sendmail/send_help_feedback_mail_photographer/",
        data,
        makeHeader()
    )
}

export const setPasswordApi = async (data) => {
    return await axios.post(
        window.LOCAL_SETTINGS.API_BASE + "/api/login/set_password/",
        data
    )
}

export const editProfile = async (formData) => {
    return await axios.post(
        window.LOCAL_SETTINGS.API_BASE + "/api/editprofile/",
        formData,
        makeHeader()
    )
}

export const getPrice = async (pid) => {
    return await axios.get(
        window.LOCAL_SETTINGS.API_BASE +
            "/api/getprice/get_price_by_pid/?pid=" +
            pid,
        makeHeader()
    )
}

export const getPriceByGid = async (gid) => {
    return await axios.get(
        window.LOCAL_SETTINGS.API_BASE +
            "/api/getpricebygid/get_price_by_gid/?gid=" +
            gid,
        makeHeader()
    )
}

export const createPrice = async (data) => {
    return await axios.post(
        window.LOCAL_SETTINGS.API_BASE + "/api/createprice/",
        data,
        makeHeader()
    )
}

export const updatePrice = async (data, priceId) => {
    return await axios.put(
        window.LOCAL_SETTINGS.API_BASE + "/api/updateprice/" + priceId,
        data,
        makeHeader()
    )
}

export const getImgGallery = async () => {
    return await axios.get(
        window.LOCAL_SETTINGS.API_BASE + "/api/getimggallery/",
        makeHeader()
    )
}

export const getPhotosByGalleryName = async (gallery_id) => {
    return await axios.get(
        window.LOCAL_SETTINGS.API_BASE +
            "/api/getphotos/getphotosbygid/?gid=" +
            gallery_id,
        makeHeader()
    )
}

export const removePhotosByIds = async (pIds, gallery_id) => {
    const sendData = {
        pIds: pIds,
        gallery_id: gallery_id,
    }
    return await axios.post(
        window.LOCAL_SETTINGS.API_BASE + "/api/deletephotos/",
        sendData,
        makeHeader()
    )
}

export const updatePricebyPhotoId = async (data) => {
    return await axios.post(
        window.LOCAL_SETTINGS.API_BASE + "/api/updatepricebypid/",
        data,
        makeHeader()
    )
}

export const upDatePhotoPriceByGalleryId = async (price_data, gid) => {
    const sendData = {
        price_data: price_data,
        gallery_id: gid,
    }
    return await axios.post(
        window.LOCAL_SETTINGS.API_BASE + "/api/updatephotopricebygid/",
        sendData,
        makeHeader()
    )
}

export const upLoadPhoto = async (data) => {
    return await axios.post(
        window.LOCAL_SETTINGS.API_BASE + "/api/uploadphotobygalleryid/",
        data,
        makeHeader()
    )
}
export const getLedgerByPhotoGrapherId = async (pid) => {
    return await axios.get(
        window.LOCAL_SETTINGS.API_BASE +
            "/api/ledger/get_ledger_by_photographerid/?pid=" +
            pid,
        makeHeader()
    )
}

export const getGalleriesByMonth = async (month) => {
    return await axios.get(
        window.LOCAL_SETTINGS.API_BASE +
            "/api/getimggallery/get_gallery_by_month/?month=" +
            month,
        makeHeader()
    )
}

export const getCountryDefaultValue = async (country_id) => {
    return await axios.get(
        window.LOCAL_SETTINGS.API_BASE +
            "/api/getpricebycustomer/get_country_value/?country=" + country_id,
        makeHeader()
    )
}

export const getLocation = async (ip_address) => {
    return await axios.get(
        window.LOCAL_SETTINGS.API_BASE +
            "/api/getlocation/get_location/?ip_address=" +
            ip_address
    )
}

export const getPrintableAwsUploadSigninUrl = async (country_code, file_name, gallery_id = null) => {
    return await axios.get(
        window.LOCAL_SETTINGS.API_BASE +
            "/api/gallery/get_printable_aws_upload_signin_url/?country=" +
            country_code +
            "&file_name=" +
            file_name +
            "&gallery_id=" +
            gallery_id,
        makeHeader()
    )
}

export const removeLocalStorage = () => {
    clearAllStorage()
}

